import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useInternational } from '@/common/locale';
import { type IconType } from '@/types/icon.types';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import {
  useSharedMenuSearchData,
  useFavoriteDashboards,
} from '@/common/components/organisms/menuSearch/menuSearch.uses';

export const setup = () => {
  const router = useRouter();

  const { isShowMenuSearch } = storeToRefs(useBaseMenuStore());

  const { t } = useInternational();

  const { favoriteDashboardList } = useFavoriteDashboards();
  const { isDashboardListError, isHistoryMenuError } = useSharedMenuSearchData();

  const favoriteDashboardErrorIcon = computed<IconType>(() =>
    isDashboardListError.value ? 'icon-warning' : 'icon-grid',
  );
  const favoriteDashboardErrorMessage = computed(() =>
    isDashboardListError.value
      ? t('MESSAGE.GNB_SEARCH_DEFAULT_ERROR_MESSAGE')
      : t('MESSAGE.GNB_SEARCH_DEFAULT_FAVORITE_EMPTY_MESSAGE'),
  );

  const onViewAllFavoriteDashboard = async () => {
    isShowMenuSearch.value = false;

    const route = router.currentRoute.value;
    if (route.path === '/dashboard/list' && route.query.favoriteOnly === 'true') {
      await router.replace({ path: '/dashboard/list' });
    }
    router.push({ path: '/dashboard/list', query: { favoriteOnly: 'true' } });
  };
  return {
    t,
    favoriteDashboardList,
    isHistoryMenuError,
    favoriteDashboardErrorIcon,
    favoriteDashboardErrorMessage,
    onViewAllFavoriteDashboard,
  };
};
